import { FC, useState } from 'react';

import { CampaignType } from 'utils/constants/campaign';

import dashboardCampaignButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/common/dashboard_campaign_button_click';

import Tabs, { Tab } from 'bloko/blocks/tabs';

import useTrls from 'hooks/translation/useTrls';

import Banners from 'components/CampaignCard/BannersTabs/Banners';
import TabLink from 'components/CampaignCard/BannersTabs/TabLink/TabLink';

import { Banner, FrontendStatusType } from 'store/models/dashboard';

import styles from 'components/CampaignCard/BannersTabs/BannerTabs.module.less';

const LAST_BANNERS = 'lastBanners';
const ALL_BANNERS = 'allBanners';
const YOUR_BANNER = 'yourBanner';

interface BannersTabsProps {
    banners: Banner[];
    campaignStatus: FrontendStatusType;
    countBanners: number;
    campaignId: number;
    advertisingServiceType: CampaignType;
    vacancyId: number | null;
}

const BannersTabs: FC<BannersTabsProps> = ({
    campaignId,
    countBanners,
    banners,
    campaignStatus,
    vacancyId,
    advertisingServiceType,
}) => {
    const [activeTab, setActiveTab] = useState<string>(countBanners > 1 ? ALL_BANNERS : YOUR_BANNER);

    const trl = useTrls();

    const TABS = {
        [LAST_BANNERS]: trl('campaign.tabsBanner.lastBanner'),
        [ALL_BANNERS]: `${trl('campaign.tabsBanner.allBanners')} ${countBanners}`,
    };

    const TAB = {
        [YOUR_BANNER]: trl('campaign.tabsBanner.yourBanner'),
    };

    const bannerList = activeTab === LAST_BANNERS ? banners.slice(0, 1) : banners;

    return (
        <div className={styles.clickmeBannersTabs}>
            <Tabs
                onChange={(action) => {
                    switch (action) {
                        case LAST_BANNERS:
                            dashboardCampaignButtonClick({
                                buttonName: 'banners_tab_last_banner',
                                campaignId,
                            });
                            break;
                        case ALL_BANNERS:
                            dashboardCampaignButtonClick({
                                buttonName: 'banners_tab_all_banners',
                                campaignId,
                            });
                            break;
                    }
                    setActiveTab(action as string);
                }}
            >
                {Object.entries(countBanners > 1 ? TABS : TAB).map(([index, tab]) => (
                    <Tab
                        key={index}
                        active={activeTab === index}
                        id={index}
                        Element={TabLink}
                        isActive={activeTab === index}
                        dataQa={index === ALL_BANNERS ? 'ad-block__all-banners' : 'ad-block__last-banner'}
                    >
                        {tab}
                    </Tab>
                ))}
            </Tabs>
            <Banners
                banners={bannerList}
                campaignId={campaignId}
                campaignStatus={campaignStatus}
                vacancyId={vacancyId}
                advertisingServiceType={advertisingServiceType}
            />
        </div>
    );
};

export default BannersTabs;
